import React from 'react';
import { useRouterActions } from 'react-resource-router';
import { Text } from '@atlaskit/primitives/compiled';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
export const FormValidationMessage = ({
  formValidationResultMessage
}) => {
  const {
    push
  } = useRouterActions();
  return /*#__PURE__*/React.createElement(SectionMessage, {
    title: formValidationResultMessage.title,
    appearance: "error",
    actions: formValidationResultMessage.actions.map(action => {
      var _action$onClick;
      return /*#__PURE__*/React.createElement(SectionMessageAction, {
        onClick: (_action$onClick = action.onClick) !== null && _action$onClick !== void 0 ? _action$onClick : () => action.href && push(action.href)
      }, action.content);
    })
  }, /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, formValidationResultMessage.description));
};